module.exports = __webpack_public_path__ + "fonts/d70e800e27a03bf57ea2115a5721350f.svg";